module.exports = __webpack_public_path__ + "static/media/certificat2.3656333b.webp";